/**
 * One-time migration of localStorage keys from az104_* to cloudmaster_*.
 * Runs on app startup. Copies values then removes old keys.
 * Sets a flag to prevent re-running on subsequent loads.
 */
const MIGRATION_KEY = 'cloudmaster_ls_migrated';

/** Static key mapping for well-known keys. */
const KEY_MAP: Record<string, string> = {
  'az104_token': 'cloudmaster_token',
  'az104_theme': 'cloudmaster_theme',
  'az104_page_size': 'cloudmaster_page_size',
  'az104_view_count': 'cloudmaster_view_count',
};

export function migrateLocalStorage(): void {
  if (localStorage.getItem(MIGRATION_KEY)) return;

  // Migrate static keys
  for (const [oldKey, newKey] of Object.entries(KEY_MAP)) {
    const value = localStorage.getItem(oldKey);
    if (value !== null) {
      localStorage.setItem(newKey, value);
      localStorage.removeItem(oldKey);
    }
  }

  // Migrate dynamic keys (e.g. az104_cursor_<topic>_<difficulty>)
  // Collect first to avoid mutating localStorage during iteration
  const dynamicMigrations: [string, string][] = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.startsWith('az104_')) {
      const newKey = key.replace('az104_', 'cloudmaster_');
      dynamicMigrations.push([key, newKey]);
    }
  }
  for (const [oldKey, newKey] of dynamicMigrations) {
    const value = localStorage.getItem(oldKey);
    if (value !== null) {
      localStorage.setItem(newKey, value);
      localStorage.removeItem(oldKey);
    }
  }

  localStorage.setItem(MIGRATION_KEY, '1');
}
